export const AuthReducerActionType: { LOG_IN: string; LOG_OUT: string } = {
  LOG_IN: "LOG_IN",
  LOG_OUT: "SIGN_OUT",
};
